// extracted by mini-css-extract-plugin
module.exports = {"footerMenu":"_3r_2mmr","heading":"_2b2PTUO","arrow":"_2n-I2sK","footerMenuLinks":"_fsgEi4N","footerMenuLink":"_1Vv83ey","open":"_1O4gMN6"};